import { RootState } from '../store';

export const getApplications = (state: RootState) => state.application.applications;
export const getApplicationLoadingStatus = (state: RootState) =>
  state.application.isFetching;
